import React, { useContext } from 'react';
import { Layout, Menu, Dropdown, Avatar } from 'antd';
import {
  DownOutlined,
  LogoutOutlined,
  SwapOutlined,
  BookOutlined,
} from '@ant-design/icons';
import { localizationConstants } from 'constants/index';
import { localizationHelpers, userHelpers } from 'helpers';
import { t } from 'helpers/i18n';
import { IRegionItem } from 'data';
import { StoreContext } from 'contexts';
// import GuideContainer from 'containers/Guide/GuideContainer';
import { Link } from 'react-router-dom';
import { openDocumentation } from 'helpers/documentation';

const { Header } = Layout;
const { REGIONS } = localizationConstants;
const { getCurrentLanguage, changeLanguage } = localizationHelpers;
const { logout } = userHelpers;

const AppHeader: React.FC<any> = (props: any) => {
  const { currentUser } = useContext(StoreContext);

  const localizationMenu = (
    <Menu>
      {Object.values(REGIONS).map((el: IRegionItem) => (
        <Menu.Item key={el.key} onClick={() => changeLanguage(el.key)}>
          <Avatar src={el.flag} shape="square" />
          <span style={{ marginLeft: 10 }}>{el.name}</span>
        </Menu.Item>
      ))}
    </Menu>
  );

  const userMenu = (
    <Menu>
      <Menu.Item data-testid="btn-logout" onClick={logout}>
        <LogoutOutlined />
        <span>{t('Logout')}</span>
      </Menu.Item>
    </Menu>
  );

  const currentRegion = REGIONS[getCurrentLanguage()];

  return (
    <Header className="app-header">
      <div className="header-row">
        <div className="app-logo">
          <Link to="/">
            <img src="https://teko.vn/images/logo-primary.svg" alt="logo" />
          </Link>
        </div>

        <div className="header-custom">{props.children}</div>

        <Link className="app-user" to="/v2/projects">
          <SwapOutlined id="guide-header-icon" className="app-icon" />
          <span className="name">{t('Switch to v2')}</span>
        </Link>

        <span className="app-user" onClick={openDocumentation}>
          <BookOutlined id="guide-header-icon" className="app-icon" />
          <span className="name">{t('Go to docs')}</span>
        </span>

        {/* Link to system guideline (documentation) */}
        {/* <Popover
          placement="bottom"
          title={t('App Guide')}
          content={<GuideContainer />}
          trigger="click"
          getPopupContainer={() =>
            document.getElementById('guide-header-icon') || document.body
          }
        >
          <QuestionCircleOutlined id="guide-header-icon" className="app-icon" />
        </Popover> */}

        <Dropdown overlay={localizationMenu} trigger={['click']}>
          <span className="app-user">
            <Avatar src={currentRegion && currentRegion.flag} shape="square" />
            <span className="name">{currentRegion && currentRegion.name}</span>
          </span>
        </Dropdown>

        <Dropdown overlay={userMenu} trigger={['click']}>
          <span className="app-user">
            <Avatar src={currentUser.picture} />
            <span className="name">{currentUser.name}</span>
            <DownOutlined />
          </span>
        </Dropdown>
      </div>
    </Header>
  );
};

export default AppHeader;
